<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-repeat"></i> {{ _('Subscriptions') }}</h3>
          <div class="component-title-buttons">
            <button class="newSelector btn btn-success addbutton" type="button" v-on:click.stop="createNew"><i class="fa fa-fw fa-plus"></i><span class="hidden-xs"> {{ _('Create new...') }}</span></button>
          </div>
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <input class="form-control" type="text" v-model="search" :placeholder="_('Keyword search')" />
          </div>
        </div>
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <select class="form-control" v-model="status" :aria-label="_('Status')">
              <option value="open">{{ _('Active and suspended') }}</option>
              <option value="active">{{ _('Active') }}</option>
              <option value="suspended">{{ _('Suspended') }}</option>
              <option value="ended">{{ _('Ended') }}</option>
              <option value="">{{ _('All') }}</option>
            </select>
          </div>
        </div>
      </div>
      <Datatable :url="subscriptionsUrl" :search="search" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import components from '~/lib/components'
import formatters from '~/lib/formatters'
import subscriptionhelpers from '~/lib/subscriptionhelpers'
import Datatable from '~/components/Datatable'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      status: 'open',
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [{
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 5,
          responsive: 0
        },
        {
          title: _('Email'),
          field: 'email',
          widthGrow: 4
        },
        {
          title: _('Status'),
          field: 'status',
          widthGrow: 2,
          headerSort: false,
          formatter: (cell) => {
            const s = cell.getRow().getData()
            return '<span class="label label-' + $this.statusClass(s) + '">' + $this.statusName(s) + '</span>'
          }
        },
        {
          title: _('Interval'),
          field: 'interval',
          widthGrow: 2,
          headerSort: false,
          formatter: (cell) => {
            const s = cell.getRow().getData()
            return $this.intervalName(s.interval, s.interval_count)
          }
        },
        {
          title: _('Valid until'),
          field: 'valid_until_ts',
          widthGrow: 2,
          headerSort: false,
          formatter: (cell) => $this.formatLastDay(cell.getValue())
        },
        {
          title: _('Next billing'),
          field: 'next_billing_ts',
          widthGrow: 2,
          headerSort: false,
          formatter: (cell) => $this.formatDate(cell.getValue())
        }
        ],
        rowClick (e, row) {
          const data = row.getData()
          $this.openSubscription(data.id, data.name)
        }
      }
    }
  },
  computed: {
    subscriptionsUrl () {
      return this.baseDomain + this.shopId + '/subscriptions.json?apikey=' + this.apiKey + (this.status ? '&status=' + this.status : '')
    }
  },
  mixins: [components, formatters, subscriptionhelpers],
  methods: {
    openSubscription (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'SubscriptionDetails',
        title: this._('Subscription') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          subscriptionId: id
        },
        skipState
      })
    },
    createNew () {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'SubscriptionDetails',
        title: this._('New subscription'),
        width: 6,
        data: {}
      })
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if (!this.events) {
      let events = {}
      events['subscriptionUpdate'] = debounce(() => {
        return this.reload()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        if (message.component === 'SubscriptionDetails' && message.data && message.data.subscriptionId) {
          this.openSubscription(message.data.subscriptionId, null, true)
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>
